import { HistoryDto, HistoryEntityType, UpdateHistoryDto } from 'types/histories';
import { portalAPI } from './portalAPI';

const APIHistoriesSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['HistoryListItems', 'Invoices'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getHistory: builder.query<HistoryDto[], { entityType: string; entityId: string; fieldType: string }>({
                query: ({ entityType, entityId, fieldType }) =>
                    `/v1/entity-field-history?entityType=${entityType}&entityId=${entityId}&fieldType=${fieldType}`,
                providesTags: (_1, _2, arg) => [
                    {
                        type: 'HistoryListItems',
                        historySelector: {
                            entityType: arg.entityType,
                            entityId: arg.entityId,
                            fieldType: arg.fieldType,
                        },
                    },
                ],
            }),

            updateHistory: builder.mutation<
                HistoryDto,
                { historyId: number; entityType: string; entityId: string; fieldType: string; body: UpdateHistoryDto }
            >({
                query: ({ historyId, body }) => ({
                    url: `/v1/entity-field-history/${historyId}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: (_1, _2, arg) => [
                    {
                        type: 'HistoryListItems',
                        historySelector: {
                            entityType: arg.entityType,
                            entityId: arg.entityId,
                            fieldType: arg.fieldType,
                        },
                    },
                ],
            }),

            deleteHistory: builder.mutation<
                void,
                { historyId: number; entityType: string; entityId: string; fieldType: string }
            >({
                query: ({ historyId }) => ({
                    url: `/v1/entity-field-history/${historyId}`,
                    method: 'DELETE',
                }),
                invalidatesTags: (_1, _2, arg) => [
                    {
                        type: 'HistoryListItems',
                        historySelector: {
                            entityType: arg.entityType,
                            entityId: arg.entityId,
                            fieldType: arg.fieldType,
                        },
                    },
                    // Deleting the current record reverts the entity's live value on the backend, so the
                    // entity itself must be refetched. Only invoices opt into deletion for now.
                    ...(arg.entityType === HistoryEntityType.INVOICE
                        ? [{ type: 'Invoices' as const, id: arg.entityId }]
                        : []),
                ],
            }),
        }),
    });

export const { useGetHistoryQuery, useUpdateHistoryMutation, useDeleteHistoryMutation } = APIHistoriesSlice;
